(($, Drupal) => {
  Drupal.behaviors.video = {
    attach: function attach() {
      $('.video').once('add').each(function (index) {
        const el = $(this);
        const openHandlerEl = el.find('.video--opener');
        const closeHandlerEl = el.find('.video--closer');
        const overlayEl = el.find('.overlay');
        const containerVideo = el.find('#video-content').get(0);

        function closeOutClick(e) {
          if (!e.target.closest('.video-popup')) {
            overlayEl.fadeOut();

            document.removeEventListener('click', closeOutClick);
            containerVideo.innerHTML = '';
          }
        }

        openHandlerEl.once('add').on('click', function (e) {
          e.stopPropagation();

          const youtubeCode = $(this).attr('data-src');
          const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
          const match = youtubeCode.match(regExp);
          const videoId = match && match[7].length === 11 ? match[7] : false;
          const youtubeLayout = `<iframe src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

          containerVideo.insertAdjacentHTML('beforeend', youtubeLayout);
          overlayEl.fadeIn();

          document.addEventListener('click', closeOutClick);
        });

        closeHandlerEl.once('add').on('click', (e) => {
          e.stopPropagation();
          containerVideo.innerHTML = '';
          overlayEl.fadeOut();
        });
      });
    },
  };
})(jQuery, Drupal);
